import {
  combineData,
  combineObjectValues,
  splitByDayAndMonth,
  splitDataObjByDayAndMonth,
} from "./helpers";

// import * as XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";

export function brandCoreAttDataTransform(
  data,
  selectedOptionShow,
  value,
  selectedProductItems
) {
  let structuredData = {};
  const dateSeriesData = {};

  // Process each entry in the data array
  data.forEach((entry) => {
    const {
      day,
      month,
      year,
      core_attribute,
      avg_score,
      customer_llm,
      score_explanation,
    } = entry;
    const { name } = core_attribute;
    const selectedBrandOrProductName =
      selectedOptionShow === "Product"
        ? entry?.customer_brand_product_persona?.customer_brand_product?.product
          ?.name ||
        selectedProductItems[0] ||
        `${month}-${day}-${year}`
        : entry?.customer_brand_persona?.customer_brand?.brand?.name;
    const { llm, market, geography } = customer_llm;
    const { persona, category } =
      selectedOptionShow === "Product"
        ? entry?.customer_brand_product_persona
        : entry?.customer_brand_persona;

    const displayName =
      value === 4
        ? market?.name === "General Market"
          ? geography?.name
          : `${geography?.name} (${market?.name})`
        : value === 5
          ? persona?.name
          : value === 1
            ? category?.name
            : value === 7
              ? `${month}-${day}-${year}`
              : llm?.name;

    // const displayName = `${month}-${day}-${year}`;

    if (!structuredData[day]) {
      structuredData[day] = {};
    }
    if (!dateSeriesData[day]) {
      dateSeriesData[day] = {};
    }

    structuredData[day][selectedBrandOrProductName] = {
      ...structuredData[day][selectedBrandOrProductName],
      [name]: Number(avg_score).toFixed(0),
    };
    dateSeriesData[day][displayName] = {
      ...dateSeriesData[day][displayName],
      [name]: {
        value: Number(avg_score).toFixed(0),
        explanation: score_explanation,
      },
    };
  });

  return { structuredData, dateSeriesData };
}

export function brandCategoryDimDataTransform(
  data,
  selectedOptionShow,
  value,
  selectedProductItems
) {
  let structuredData = {};
  const dateSeriesData = {};

  // Process each entry in the data array
  data.forEach((entry) => {
    const {
      day,
      month,
      year,
      category_dimension,
      avg_rating,
      customer_llm,
      explanation,
    } = entry;
    const { name } = category_dimension;
    const selectedBrandOrProductName =
      selectedOptionShow === "Product"
        ? entry?.customer_brand_product_persona?.customer_brand_product?.product
          ?.name ||
        selectedProductItems[0] ||
        `${month}-${day}-${year}`
        : entry?.customer_brand_persona?.customer_brand?.brand?.name;
    const { llm, market, geography } = customer_llm;
    const { persona, category } =
      selectedOptionShow === "Product"
        ? entry?.customer_brand_product_persona
        : entry?.customer_brand_persona;
    const displayName =
      value === 4
        ? market?.name === "General Market"
          ? geography?.name
          : `${geography?.name} (${market?.name})`
        : value === 5
          ? persona?.name
          : value === 1
            ? category?.name
            : value === 7
              ? `${month}-${day}-${year}`
              : llm?.name;

    // const displayName = `${month}-${day}-${year}`;

    if (!structuredData[day]) {
      structuredData[day] = {};
    }
    if (!dateSeriesData[day]) {
      dateSeriesData[day] = {};
    }

    structuredData[day][selectedBrandOrProductName] = {
      ...structuredData[day][selectedBrandOrProductName],
      [name]: Number(avg_rating).toFixed(0),
    };
    dateSeriesData[day][displayName] = {
      ...dateSeriesData[day][displayName],
      [name]: { value: Number(avg_rating).toFixed(0), explanation },
    };
  });

  return { structuredData, dateSeriesData };
}

function getRecentLlmModelDataPerGroup(arr, groupKeys, _scoreKey) {

  const groups = {};
  arr.forEach(obj => {
    const provider = obj?.customer_llm?.llm?.llm_provider;
    const baseKey = groupKeys.map(k => obj[k]).join("_");
    const key = `${baseKey}_${provider}`;
    if (!groups[key]) groups[key] = [];
    groups[key].push(obj);

  });

  const result = [];

  Object.values(groups).forEach(items => {
    const firstId = items[0]?.customer_llm?.id;
    const allSameId = items.every(item => item?.customer_llm?.id === firstId);

    if (allSameId) {
      // Same id across the group — keep all records
      result.push(...items);
    } else {
      // Different ids — find the max customer_llm.id, then keep ALL items that share that max id
      const maxId = Math.max(...items.map(item => item?.customer_llm?.id ?? -Infinity));
      result.push(...items.filter(item => (item?.customer_llm?.id ?? -Infinity) === maxId));
    }
  });
  return result;
}

export function transformBrandIndexMultiLlmData(
  compData,
  data,
  targetIndex,
  selectedOptionShow,
  value,
  selectedProductItems,
  selectedBrandItems
) {

  data = getRecentLlmModelDataPerGroup(data, ['day', 'month', 'year'], 'customer_llm_id');
  compData = getRecentLlmModelDataPerGroup(compData, ['day', 'month', 'year'], 'customer_llm_id');

  const result = {};
  const structuredData = {};
  const selectedBrandOrProductName =
    selectedOptionShow === "Product"
      ? selectedProductItems[0] || "MainProduct"
      : selectedBrandItems[0] || "MainBrand";

  // Process each entry in the data array
  data.forEach((entry) => {
    const { day, month, year, customer_llm } = entry;
    const { llm, market, geography } = customer_llm;
    const { persona, category } =
      selectedOptionShow === "Product"
        ? entry?.customer_brand_product_persona
        : entry?.customer_brand_persona;
    const displayName =
      value === 4
        ? market?.name === "General Market"
          ? geography?.name
          : `${geography?.name} (${market?.name})`
        : value === 5
          ? persona?.name
          : value === 1
            ? category?.name
            : value === 7
              ? `${month}-${day}-${year}`
              : llm?.name;

    if (!structuredData[day]) {
      structuredData[day] = {};
    }

    structuredData[day][selectedBrandOrProductName] = {
      ...structuredData[day][selectedBrandOrProductName],
      [displayName]: entry[targetIndex],
    };
  });

  // Iterate through the data array
  compData.forEach((item) => {
    const day = item.day;
    const month = item.month;
    const year = item.year;
    const brandName =
      selectedOptionShow === "Product"
        ? item.brand_product?.name
        : item.brand.name;
    const llmName = item?.customer_llm?.llm?.name;
    const { market, geography } = item?.customer_llm;
    const { persona, category } =
      selectedOptionShow === "Product"
        ? item?.customer_brand_product_persona
        : item?.customer_brand_persona;
    const displayName =
      value === 4
        ? market?.name === "General Market"
          ? geography?.name
          : `${geography?.name} (${market?.name})`
        : value === 5
          ? persona?.name
          : value === 1
            ? category?.name
            : value === 7
              ? `${month}-${day}-${year}`
              : llmName;
    const avgScore = item[targetIndex];

    // Initialize the day object if it doesn't exist
    if (!result[day]) {
      result[day] = {};
    }

    // Initialize the brand object if it doesn't exist
    if (!result[day][brandName]) {
      result[day][brandName] = {};
    }

    // Add the core attribute and its average score to the brand object
    result[day][brandName][displayName] = Number(avgScore).toFixed(0);
  });

  let mergedData = mergeDeep({ ...result }, structuredData);
  mergedData = sortDataByMarket(
    mergedData,
    selectedBrandItems,
    selectedProductItems
  );
  return mergedData;
}

export const mergeDeep = (target, source) => {
  for (const key in source) {
    if (source[key] instanceof Object && target[key] instanceof Object) {
      // Merge subkeys
      for (const subKey in source[key]) {
        target[key][subKey] = source[key][subKey];
      }
    } else if (source[key] instanceof Object) {
      // Add new nested object
      target[key] = { ...source[key] };
    } else {
      // Assign value from source to target
      target[key] = source[key];
    }
  }
  return target;
};

export function sortDataByMarket(
  data,
  selectedBrandItems,
  selectedProductItems
) {
  const sortedData = {};

  // Sort dates in ascending order
  const dates = Object.keys(data).sort((a, b) => parseInt(a) - parseInt(b));

  // Collect all unique markets from all dates
  const allMarkets = new Set();
  dates.forEach((date) => {
    Object.values(data[date]).forEach((locations) => {
      Object.keys(locations).forEach((market) => {
        allMarkets.add(market);
      });
    });
  });

  // Sort markets with "General Market" first
  const sortedMarkets = Array.from(allMarkets).sort((a, b) => {
    if (
      a === "General Market" ||
      a === "General Persona" ||
      a === selectedBrandItems[0] ||
      a === selectedProductItems[0]
    )
      return -1;
    if (
      b === "General Market" ||
      b === "General Persona" ||
      b === selectedBrandItems[0] ||
      b === selectedProductItems[0]
    )
      return 1;
    return 0;
  });

  // Sort data according to the sorted markets
  dates.forEach((date) => {
    sortedData[date] = {};
    Object.keys(data[date]).forEach((company) => {
      sortedData[date][company] = {};
      sortedMarkets.forEach((market) => {
        if (data[date][company][market] !== undefined) {
          sortedData[date][company][market] = data[date][company][market];
        }
      });
    });
  });

  return sortedData;
}

export function calculateAverageData(data, allowZero) {
  if (data) {
    const result = {};
    const dates = Object.keys(data);

    // Initialize result object with all markets and attributes
    dates.forEach((date) => {
      const markets = data[date];
      Object.keys(markets).forEach((market) => {
        if (!result[market]) {
          result[market] = {};
        }
        Object.keys(markets[market]).forEach((attribute) => {
          if (!result[market][attribute]) {
            result[market][attribute] = { sum: 0, count: 0 };
          }
        });
      });
    });

    // Accumulate sums and counts
    dates.forEach((date) => {
      const markets = data[date];
      Object.keys(markets).forEach((market) => {
        Object.keys(markets[market]).forEach((attribute) => {
          const value = parseFloat(markets[market][attribute]) || 0;

          // result[market][attribute].sum += value;
          // result[market][attribute].count += 1;

          if ((allowZero && value === 0) || value) {
            result[market][attribute].sum += value;
            result[market][attribute].count += 1;
          }
        });
      });
    });

    // Calculate averages
    const averages = {};
    Object.keys(result).forEach((market) => {
      averages[market] = {};
      Object.keys(result[market]).forEach((attribute) => {
        const { sum, count } = result[market][attribute];
        // averages[market][attribute] = sum / count;
        averages[market][attribute] =
          count > 0 ? Number(sum / count).toFixed(0) : 0;
      });
    });

    return { avg: averages };
  }
}

export function calculateAverageDataStructure(data) {
  if (data) {
    const result = {};
    const dates = Object.keys(data);

    // Initialize result object with all markets and attributes
    dates.forEach((date) => {
      const markets = data[date];
      Object.keys(markets).forEach((market) => {
        if (!result[market]) {
          result[market] = {};
        }
        Object.keys(markets[market]).forEach((attribute) => {
          if (!result[market][attribute]) {
            result[market][attribute] = {
              sum: 0,
              count: 0,
              closestExplanation: null,
              minDiff: Infinity,
            };
          }
        });
      });
    });

    // Accumulate sums, counts, and find closest explanation
    dates.forEach((date) => {
      const markets = data[date];
      Object.keys(markets).forEach((market) => {
        Object.keys(markets[market]).forEach((attribute) => {
          const attributeData = markets[market][attribute];
          const value = parseFloat(attributeData.value) || 0;

          if (value && value !== 0) {
            result[market][attribute].sum += value;
            result[market][attribute].count += 1;

            // Keep track of explanation closest to the average
            const avg =
              result[market][attribute].sum / result[market][attribute].count;
            const diff = Math.abs(value - avg);
            if (diff < result[market][attribute].minDiff) {
              result[market][attribute].minDiff = diff;
              result[market][attribute].closestExplanation =
                attributeData.explanation;
            }
          }
        });
      });
    });

    // Calculate averages and return the closest explanation
    const averages = {};
    Object.keys(result).forEach((market) => {
      averages[market] = {};
      Object.keys(result[market]).forEach((attribute) => {
        const { sum, count, closestExplanation } = result[market][attribute];
        averages[market][attribute] = {
          avgValue: count > 0 ? sum / count : 0,
          explanation: closestExplanation,
        };
      });
    });

    return { avg: averages };
  }
}

export const transformDataForAttributes = (
  data,
  value,
  selectedBrandItems,
  selectedProductItems
) => {
  if (data && data.length > 0) {
    let positiveAttributesStructuredData = {};
    let negativeAttributesStructuredData = {};

    const positiveAttributes = data.filter((obj) => obj.is_positive);
    const negativeAttributes = data.filter((obj) => !obj.is_positive);

    // Process each entry in the data array

    positiveAttributes.forEach((entry) => {
      const { day, month, year, attribute, signal_strength, customer_llm } =
        entry;
      const { name } = attribute;
      const { llm, market, geography } = customer_llm;
      const persona =
        entry?.customer_brand_persona?.persona?.name ||
        entry?.customer_brand_product_persona?.persona?.name;
      const category =
        entry?.customer_brand_persona?.category?.name ||
        entry?.customer_brand_product_persona?.category?.name;
      const displayName =
        value === 4
          ? market?.name === "General Market"
            ? geography?.name
            : `${geography?.name} (${market?.name})`
          : value === 5
            ? persona
            : value === 1
              ? category
              : value === 7
                ? `${month}-${day}-${year}`
                : llm?.name;

      if (!positiveAttributesStructuredData[day]) {
        positiveAttributesStructuredData[day] = {};
      }

      positiveAttributesStructuredData[day][displayName] = {
        ...positiveAttributesStructuredData[day][displayName],
        [name]: signal_strength,
      };
    });

    negativeAttributes.forEach((entry) => {
      const { day, month, year, attribute, signal_strength, customer_llm } =
        entry;
      const { name } = attribute;
      const { llm, market, geography } = customer_llm;
      const persona =
        entry?.customer_brand_persona?.persona?.name ||
        entry?.customer_brand_product_persona?.persona?.name;

      const category =
        entry?.customer_brand_persona?.category?.name ||
        entry?.customer_brand_product_persona?.category?.name;
      const displayName =
        value === 4
          ? market?.name === "General Market"
            ? geography?.name
            : `${geography?.name} (${market?.name})`
          : value === 5
            ? persona
            : value === 1
              ? category
              : value === 6
                ? `${month}-${day}-${year}`
                : llm?.name;

      if (!negativeAttributesStructuredData[day]) {
        negativeAttributesStructuredData[day] = {};
      }

      negativeAttributesStructuredData[day][displayName] = {
        ...negativeAttributesStructuredData[day][displayName],
        [name]: signal_strength,
      };
    });

    positiveAttributesStructuredData = sortDataByTargetKey(
      positiveAttributesStructuredData,
      selectedBrandItems,
      selectedProductItems
    );
    negativeAttributesStructuredData = sortDataByTargetKey(
      negativeAttributesStructuredData,
      selectedBrandItems,
      selectedProductItems
    );
    return {
      positiveAttributesStructuredData,
      negativeAttributesStructuredData,
    };
  }
};

export function sortDataByTargetKey(
  data,
  selectedBrandItems,
  selectedProductItems
) {
  const sortedData = {};

  const dates = Object.keys(data).sort((a, b) => parseInt(a) - parseInt(b));

  // Collect all unique markets from all dates
  const allMarkets = new Set();
  dates.forEach((date) => {
    Object.keys(data[date]).forEach((market) => {
      allMarkets.add(market);
    });
  });

  // Sort markets with "General Market" first
  const sortedMarkets = Array.from(allMarkets).sort((a, b) => {
    if (
      a === "General Market" ||
      a === "General Persona" ||
      a === selectedBrandItems[0] ||
      a === selectedProductItems[0]
    )
      return -1;
    if (
      b === "General Market" ||
      b === "General Persona" ||
      b === selectedBrandItems[0] ||
      b === selectedProductItems[0]
    )
      return 1;
    return 0;
  });

  // Sort data according to the sorted markets
  dates.forEach((date) => {
    sortedData[date] = {};
    sortedMarkets.forEach((market) => {
      if (data[date][market] !== undefined) {
        sortedData[date][market] = data[date][market];
      }
    });
  });

  return sortedData;
}

export const indexScoreChartData = (
  data,
  index,
  brandName,
  productName,
  selectedOptionShow,
  selectedProductItems,
  selectedBrandItems
) => {
  const brandData =
    selectedOptionShow === "Product" ? data?.product : data?.brand;
  const compBrandsData =
    selectedOptionShow === "Product" ? data?.compProducts : data?.compBrands;
  const selectedBrandOrProduct =
    selectedOptionShow === "Product"
      ? selectedProductItems[0] || productName
      : selectedBrandItems[0] || brandName;

  const groupByDay = (arr, keyField, valueField) => {
    return arr.reduce((acc, obj) => {
      const day = obj.day;
      const month = obj.month;
      const year = obj.year;
      const key =
        keyField === selectedBrandOrProduct
          ? keyField
          : selectedOptionShow === "Product"
            ? obj.brand_product?.name
            : obj.brand.name;
      const value = parseFloat(obj[valueField]);
      const llmName = obj.llm?.name || obj.customer_llm?.llm?.name || "";
      const llmProvider = obj.llm?.llm_provider || obj.customer_llm?.llm?.llm_provider || "";
      const customerLlmId = obj.customer_llm?.id || 0;

      const dateKey = `${month}-${day}-${year}`;

      if (!acc[dateKey]) {
        acc[dateKey] = {
          llmName,
          _llmProvider: llmProvider,
          _customerLlmId: customerLlmId,
          _llmsByProvider: {}  // Track LLMs by provider for this date
        };
      }

      // Track this LLM for its provider
      if (llmProvider && llmName) {
        if (!acc[dateKey]._llmsByProvider[llmProvider]) {
          acc[dateKey]._llmsByProvider[llmProvider] = {
            llmName,
            customerLlmId
          };
        } else {
          // If we already have an LLM for this provider, keep the one with higher customerLlmId
          if (customerLlmId > acc[dateKey]._llmsByProvider[llmProvider].customerLlmId) {
            acc[dateKey]._llmsByProvider[llmProvider] = {
              llmName,
              customerLlmId
            };

            // Update the main llmName if this provider's LLM was selected
            if (llmProvider === acc[dateKey]._llmProvider) {
              acc[dateKey].llmName = llmName;
              acc[dateKey]._customerLlmId = customerLlmId;
            }
          }
        }
      } else {
        // No provider info, use simple logic: keep the one with highest customerLlmId
        if (customerLlmId > (acc[dateKey]._customerLlmId || 0)) {
          acc[dateKey].llmName = llmName;
          acc[dateKey]._llmProvider = llmProvider;
          acc[dateKey]._customerLlmId = customerLlmId;
        }
      }

      acc[dateKey][key] = value;
      return acc;
    }, {});
  };

  const compBrandsGrouped = compBrandsData.length
    ? groupByDay(compBrandsData, "name", index)
    : {};
  const brandGrouped = brandData.length
    ? groupByDay(brandData, selectedBrandOrProduct, index)
    : {};

  const allDays = new Set([
    ...Object.keys(compBrandsGrouped),
    ...Object.keys(brandGrouped),
  ]);

  let finalArray = Array.from(allDays).map((day) => {
    const compData = compBrandsGrouped[day] || {};
    const brandData = brandGrouped[day] || {};

    // Extract llmName from either dataset
    const llmName = compData.llmName || brandData.llmName || "";

    // Remove internal tracking properties and llmName from spread to avoid conflicts
    const { llmName: _, _llmProvider: _a, _customerLlmId: _b, _llmsByProvider: _c, ...restComp } = compData;
    const { llmName: __, _llmProvider: _d, _customerLlmId: _e, _llmsByProvider: _f, ...restBrand } = brandData;

    return {
      date: day, // Adding the date property
      llmName, // Add llmName to each data point
      ...restComp,
      ...restBrand,
    };
  });

  finalArray = finalArray.sort((a, b) => {
    // Convert the date strings into actual Date objects
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateA - dateB; // Sort in ascending order
  });

  return finalArray;
};

export const handleInputValidation = (
  selectedOptionShow,
  selectedBrandItems,
  selectedProductItems,
  selectedPersona,
  selectedFrequencyItems,
  value,
  selectedSubFrequencyItems,
  selectedLlmItems,
  selectedGeographyItems,
  selectedMarketItems,
  selectedCategory
) => {
  let errorMessage = "";

  if (
    selectedOptionShow === "Company/Brand" &&
    selectedBrandItems &&
    selectedBrandItems.length === 0
  ) {
    errorMessage = "Please Select a Brand !";
  } else if (
    selectedOptionShow === "Product" &&
    selectedProductItems &&
    selectedProductItems.length === 0
  ) {
    errorMessage = "Please Select a Product !";
  } else if (selectedPersona && selectedPersona.length === 0) {
    errorMessage = "Please select a Persona !";
  } else if (selectedCategory && selectedCategory.length === 0) {
    errorMessage = "Please select a Category !";
  } else if (selectedFrequencyItems && selectedFrequencyItems.length === 0) {
    errorMessage = "Please select Frequency !";
  } else if (
    value !== 0 &&
    selectedSubFrequencyItems &&
    selectedSubFrequencyItems.length === 0
  ) {
    errorMessage = "Please Select a valid date";
  } else if (!selectedLlmItems || selectedLlmItems.length === 0) {
    errorMessage = "Please select LLM !";
  } else if (selectedMarketItems && selectedMarketItems.length === 0) {
    errorMessage = "Please select Market !";
  } else if (selectedGeographyItems && selectedGeographyItems.length === 0) {
    errorMessage = "Please select Geography !";
  }

  return errorMessage;
};

export const getComparisonBrandIndexScore = (
  data,
  selectedOptionShow,
  value,
  selectedProductItems,
  selectedBrandItems
) => {
  const cumulativeCompData =
    selectedOptionShow === "Product" ? data?.compProducts : data?.compBrands;
  const cumulativebrandOrProductData =
    selectedOptionShow === "Product" ? data?.product : data?.brand;
  const brandIndexData = transformBrandIndexMultiLlmData(
    cumulativeCompData,
    cumulativebrandOrProductData,
    "avg_brand_index_score",
    selectedOptionShow,
    value,
    selectedProductItems,
    selectedBrandItems
  );

  const brandFavData = transformBrandIndexMultiLlmData(
    cumulativeCompData,
    cumulativebrandOrProductData,
    "avg_brand_favorability_score",
    selectedOptionShow,
    value,
    selectedProductItems,
    selectedBrandItems
  );

  const brandReachData = transformBrandIndexMultiLlmData(
    cumulativeCompData,
    cumulativebrandOrProductData,
    "avg_brand_reach_score",
    selectedOptionShow,
    value,
    selectedProductItems,
    selectedBrandItems
  );

  return { brandIndexData, brandFavData, brandReachData };
};

export const transformedGraphData = (data) => {
  if (data && data.length > 0) {
    const filterData = data.filter(
      (obj) => obj?.attribute?.attribute_category !== null
    );

    const positiveAttributesData = filterData.filter((obj) => obj?.is_positive);
    const negativeAttributesData = filterData.filter(
      (obj) => !obj?.is_positive
    );

    const processAttributesData = (attributesData) => {
      return attributesData.reduce((acc, item) => {
        const categoryName = item?.attribute?.attribute_category?.category_name;
        const signalStrength = Number(item?.signal_strength);
        const attributeName = item?.attribute?.name;

        // Find existing category in the accumulator
        const existingCategory = acc.find((cat) => cat?.name === categoryName);

        if (existingCategory) {
          const attributeIndex =
            existingCategory.altNames.indexOf(attributeName);

          if (attributeIndex !== -1) {
            // If the attribute already exists, update total and count for averaging
            existingCategory.signalStrengths[attributeIndex].total +=
              signalStrength;
            existingCategory.signalStrengths[attributeIndex].count += 1;
          } else {
            // Add new attribute and initialize total and count
            existingCategory.altNames.push(attributeName);
            existingCategory.signalStrengths.push({
              total: signalStrength,
              count: 1,
            });
          }

          // Recalculate the maximum value based on the average
          const maxAvgSignalStrength = Math.max(
            ...existingCategory.signalStrengths.map(
              (entry) => entry.total / entry.count
            )
          );
          existingCategory.value = maxAvgSignalStrength.toFixed(0);
        } else {
          // Create a new category entry
          acc.push({
            name: categoryName,
            value: signalStrength.toFixed(0),
            altNames: [attributeName],
            signalStrengths: [{ total: signalStrength, count: 1 }],
          });
        }

        return acc;
      }, []);
    };

    const positiveAttResult = processAttributesData(positiveAttributesData);
    const negativeAttResult = processAttributesData(negativeAttributesData);

    return { positiveAttResult, negativeAttResult };
  }
};

export const transformDataForAttributesSources = (
  data,
  sourceFilter,
  selectedBrandItems,
  selectedProductItems
) => {
  if (data && data.length > 0) {
    let positiveAttributesStructuredData = {};
    let negativeAttributesStructuredData = {};

    const positiveAttributes = data.filter((obj) => obj.is_positive);
    const negativeAttributes = data.filter((obj) => !obj.is_positive);

    // Process each entry in the data array

    positiveAttributes.forEach((entry) => {
      const { day, source, cnt_source_id, customer_llm } = entry;
      const { domain_url } = source;
      const { llm } = customer_llm;
      const persona =
        entry?.customer_brand_persona?.persona?.name ||
        entry?.customer_brand_product_persona?.persona?.name;
      const category =
        entry?.customer_brand_product_persona?.category?.name ||
        entry?.customer_brand_persona?.category?.name;
      const displayName =
        sourceFilter?.value === "LLM"
          ? llm?.name
          : sourceFilter?.value === "CATEGORY"
            ? category
            : persona;

      if (!positiveAttributesStructuredData[day]) {
        positiveAttributesStructuredData[day] = {};
      }

      positiveAttributesStructuredData[day][displayName] = {
        ...positiveAttributesStructuredData[day][displayName],
        [domain_url]: cnt_source_id,
      };
    });

    negativeAttributes.forEach((entry) => {
      const { day, source, cnt_source_id, customer_llm } = entry;
      const { domain_url } = source;
      const { llm } = customer_llm;
      const persona =
        entry?.customer_brand_persona?.persona?.name ||
        entry?.customer_brand_product_persona?.persona?.name;
      const category =
        entry?.customer_brand_product_persona?.category?.name ||
        entry?.customer_brand_persona?.category?.name;
      const displayName =
        sourceFilter?.value === "LLM"
          ? llm?.name
          : sourceFilter?.value === "CATEGORY"
            ? category
            : persona;
      if (!negativeAttributesStructuredData[day]) {
        negativeAttributesStructuredData[day] = {};
      }

      negativeAttributesStructuredData[day][displayName] = {
        ...negativeAttributesStructuredData[day][displayName],
        [domain_url]: cnt_source_id,
      };
    });

    positiveAttributesStructuredData = sortDataByTargetKey(
      positiveAttributesStructuredData,
      selectedBrandItems,
      selectedProductItems
    );
    negativeAttributesStructuredData = sortDataByTargetKey(
      negativeAttributesStructuredData,
      selectedBrandItems,
      selectedProductItems
    );

    return {
      positiveAttributesStructuredData,
      negativeAttributesStructuredData,
    };
  }
};

export const transformData = (
  data,
  index,
  brandName,
  productName,
  selectedOptionShow,
  selectedBrandItems,
  selectedProductItems
) => {
  const brandData =
    selectedOptionShow === "Product" ? data?.product : data?.brand;
  const compBrandsData =
    selectedOptionShow === "Product" ? data?.compProducts : data?.compBrands;
  const brand = selectedBrandItems[0] || brandName;
  const product = selectedProductItems[0] || productName;
  const selectedBrandOrProduct =
    selectedOptionShow === "Product" ? product : brand;

  const groupByDay = (arr, keyField, valueField) => {
    return arr.reduce((acc, obj) => {
      const day = obj.day;
      const key =
        keyField === selectedBrandOrProduct
          ? keyField
          : selectedOptionShow === "Product"
            ? obj.brand_product?.name
            : obj.brand.name;
      const value = parseFloat(obj[valueField]).toFixed(0);

      if (!acc[day]) {
        acc[day] = {};
      }

      acc[day][key] = Number(value);
      return acc;
    }, {});
  };

  const compBrandsGrouped = compBrandsData.length
    ? groupByDay(compBrandsData, "name", index)
    : {};
  const brandGrouped = brandData.length
    ? groupByDay(brandData, selectedBrandOrProduct, index)
    : {};

  const allDays = new Set([
    ...Object.keys(compBrandsGrouped),
    ...Object.keys(brandGrouped),
  ]);

  const finalArray = Array.from(allDays).map((day) => {
    return {
      ...(compBrandsGrouped[day] || {}),
      ...(brandGrouped[day] || {}),
    };
  });

  return finalArray;
};

export const getCompBrandIndexScoreAvgObj = (
  obj,
  brandName,
  productName,
  selectedOptionShow,
  selectedBrandItems,
  selectedProductItems
) => {
  const brandFavArray = transformData(
    obj,
    "avg_brand_favorability_score",
    brandName,
    productName,
    selectedOptionShow,
    selectedBrandItems,
    selectedProductItems
  );
  const brandReachArray = transformData(
    obj,
    "avg_brand_reach_score",
    brandName,
    productName,
    selectedOptionShow,
    selectedBrandItems,
    selectedProductItems
  );

  // const avgIndex = calculateAverageIndex(brandIndexArray);
  const avgFav = calculateAverageIndex(brandFavArray);
  const avgReach = calculateAverageIndex(brandReachArray);
  const avgIndex = combineObjectValues(avgReach, avgFav);

  return {
    "Brand Index Score": avgIndex,
    Favorability: avgFav,
    Rank: avgReach,
  };
};

export const calculateAverageIndex = (arr) => {
  const totals = {};
  const counts = {};

  // Iterate over each object in the array
  arr.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (!(key in totals)) {
        totals[key] = 0;
        counts[key] = 0;
      }
      totals[key] += obj[key];
      counts[key] += 1;
    });
  });

  // Calculate the averages
  const averages = {};
  for (const key in totals) {
    averages[key] = Number(totals[key] / counts[key]).toFixed(0);
  }

  return averages;
};

export function transformDataForCoreAttributes(
  compData,
  data,
  brandName,
  productName,
  selectedBrandItems,
  selectedProductItems,
  selectedOptionShow
) {
  // Initialize the result object

  const result = {};
  const structuredData = {};
  const brand = selectedBrandItems[0] || brandName;
  const product = selectedProductItems[0] || productName;
  const selectedBrandOrProductName =
    selectedOptionShow === "Product" ? product : brand;

  // Process each entry in the data array
  data.forEach((entry) => {
    const { day, core_attribute, avg_score, score_explanation } = entry;
    const { name } = core_attribute;

    if (!structuredData[day]) {
      structuredData[day] = {};
    }

    structuredData[day][selectedBrandOrProductName] = {
      ...structuredData[day][selectedBrandOrProductName],
      [name]: {
        value: Number(avg_score).toFixed(0),
        explanation: score_explanation,
      },
    };
  });

  // Iterate through the data array
  compData.forEach((item) => {
    const day = item.day;

    const brandName =
      selectedOptionShow === "Product"
        ? item?.brand_product?.name || "test"
        : item.brand.name;
    const coreAttributeName = item.core_attribute.name;
    const avgScore = item?.avg_score;
    const explanation = item?.score_explanation;

    // Initialize the day object if it doesn't exist
    if (!result[day]) {
      result[day] = {};
    }

    // Initialize the brand object if it doesn't exist
    if (!result[day][brandName]) {
      result[day][brandName] = {};
    }

    // Add the core attribute and its average score to the brand object
    result[day][brandName][coreAttributeName] = {
      value: Number(avgScore).toFixed(0),
      explanation,
    };
  });

  let mergedData = mergeDeep({ ...result }, structuredData);
  mergedData = sortDataByTargetKey(
    mergedData,
    selectedBrandItems,
    selectedProductItems
  );
  return mergedData;
}

export function transformDataForCompAttributes(
  compData,
  data,
  selectedOptionShow,
  selectedBrandItems,
  selectedProductItems
) {
  const positiveAttributesData = data.filter((obj) => obj.is_positive);
  const positiveCompAttributesData = compData.filter((obj) => obj.is_positive);
  const negativeAttributesData = data.filter((obj) => !obj.is_positive);
  const negativeCompAttributesData = compData.filter((obj) => !obj.is_positive);
  // Initialize the result object
  const result = {};
  const structuredData = {};
  const negativeAttributesResult = {};
  const negativeAttributesStructuredData = {};

  const brandName = selectedBrandItems[0] || "MainBrand";
  const productName = selectedProductItems[0] || "MainProduct";
  const selectedBrandOrProductName =
    selectedOptionShow === "Product" ? productName : brandName;

  // Process each entry in the positive attributes data array
  positiveAttributesData.forEach((entry) => {
    const { day, attribute, signal_strength } = entry;
    const { name } = attribute;

    if (!structuredData[day]) {
      structuredData[day] = {};
    }

    structuredData[day][selectedBrandOrProductName] = {
      ...structuredData[day][selectedBrandOrProductName],
      [name]: signal_strength,
    };
  });

  // Iterate through the positive comp attributes data array
  positiveCompAttributesData.forEach((item) => {
    const day = item.day;
    const brandName =
      selectedOptionShow === "Product"
        ? item?.brand_product?.name || "test"
        : item?.brand?.name;
    const attributeName = item.attribute.name;
    const signalStrength = item.signal_strength;

    // Initialize the day object if it doesn't exist
    if (!result[day]) {
      result[day] = {};
    }

    // Initialize the brand object if it doesn't exist
    if (!result[day][brandName]) {
      result[day][brandName] = {};
    }

    // Add the attribute and its signal strength to the brand object
    result[day][brandName][attributeName] = signalStrength;
  });

  // Process each entry in the positive attributes data array
  negativeAttributesData.forEach((entry) => {
    const { day, attribute, signal_strength } = entry;
    const { name } = attribute;

    if (!negativeAttributesStructuredData[day]) {
      negativeAttributesStructuredData[day] = {};
    }

    negativeAttributesStructuredData[day][selectedBrandOrProductName] = {
      ...negativeAttributesStructuredData[day][selectedBrandOrProductName],
      [name]: signal_strength,
    };
  });

  // Iterate through the positive comp attributes data array
  negativeCompAttributesData.forEach((item) => {
    const day = item.day;
    const brandName =
      selectedOptionShow === "Product"
        ? item?.brand_product?.name || "test"
        : item?.brand?.name;
    const attributeName = item.attribute.name;
    const signalStrength = item.signal_strength;

    // Initialize the day object if it doesn't exist
    if (!negativeAttributesResult[day]) {
      negativeAttributesResult[day] = {};
    }

    // Initialize the brand object if it doesn't exist
    if (!negativeAttributesResult[day][brandName]) {
      negativeAttributesResult[day][brandName] = {};
    }

    // Add the attribute and its signal strength to the brand object
    negativeAttributesResult[day][brandName][attributeName] = signalStrength;
  });

  let mergedData = mergeDeep({ ...result }, structuredData);
  let negativeAttributesMergedData = mergeDeep(
    { ...negativeAttributesResult },
    negativeAttributesStructuredData
  );
  mergedData = sortDataByTargetKey(
    mergedData,
    selectedBrandItems,
    selectedProductItems
  );
  negativeAttributesMergedData = sortDataByTargetKey(
    negativeAttributesMergedData,
    selectedBrandItems,
    selectedProductItems
  );

  return { mergedData, negativeAttributesMergedData };
}

export function transformDataForCategoryDim(
  compData,
  data,
  brandName,
  productName,
  selectedOptionShow,
  selectedBrandItems,
  selectedProductItems
) {
  // Initialize the result object

  const result = {};
  const structuredData = {};
  const brand = selectedBrandItems[0] || brandName;
  const product = selectedProductItems[0] || productName;
  const selectedBrandOrProductName =
    selectedOptionShow === "Product" ? product : brand;

  // Process each entry in the data array
  data.forEach((entry) => {
    const { day, category_dimension, avg_rating, explanation } = entry;
    const { name } = category_dimension;

    if (!structuredData[day]) {
      structuredData[day] = {};
    }

    structuredData[day][selectedBrandOrProductName] = {
      ...structuredData[day][selectedBrandOrProductName],
      [name]: { value: Number(avg_rating).toFixed(0), explanation },
    };
  });

  // Iterate through the data array
  compData.forEach((item) => {
    const day = item.day;

    const brandName =
      selectedOptionShow === "Product"
        ? item?.brand_product?.name || "test"
        : item.brand.name;
    const categoryDimName = item?.category_dimension?.name;
    const avgRating = item?.avg_rating;
    const explanation = item?.explanation;

    // Initialize the day object if it doesn't exist
    if (!result[day]) {
      result[day] = {};
    }

    // Initialize the brand object if it doesn't exist
    if (!result[day][brandName]) {
      result[day][brandName] = {};
    }

    // Add the core attribute and its average score to the brand object
    result[day][brandName][categoryDimName] = {
      value: Number(avgRating).toFixed(0),
      explanation,
    };
  });

  let mergedData = mergeDeep({ ...result }, structuredData);
  mergedData = sortDataByTargetKey(
    mergedData,
    selectedBrandItems,
    selectedProductItems
  );
  return mergedData;
}

export function processSourceData(
  data,
  isCoreAtt,
  selectedOptionShow,
  sourceFilter,
  selectedBrandItems,
  selectedProductItems
) {
  let ratingSourceResult = {};
  let sourceResult = {};

  const processEntry = (entry, resultObject) => {
    const { day, source, signal_strength, count_sources, customer_llm } = entry;
    const { domain_url } = source;
    const { llm } = customer_llm;
    const persona =
      selectedOptionShow === "Product"
        ? entry?.customer_brand_product_persona.persona.name
        : entry?.customer_brand_persona.persona.name;
    const category =
      selectedOptionShow === "Product"
        ? entry?.customer_brand_product_persona?.category?.name
        : entry?.customer_brand_persona?.category?.name;
    const displayName =
      sourceFilter?.value === "LLM"
        ? llm?.name
        : sourceFilter?.value === "CATEGORY"
          ? category
          : persona;

    if (!resultObject[day]) {
      resultObject[day] = {};
    }

    resultObject[day][displayName] = {
      ...resultObject[day][displayName],
      [domain_url]: count_sources,
    };
  };

  if (isCoreAtt) {
    if (Array.isArray(data)) {
      data.forEach((entry) => processEntry(entry, ratingSourceResult));
    }

    ratingSourceResult = sortDataByMarket(
      ratingSourceResult,
      selectedBrandItems,
      selectedProductItems
    );

    return { ratingSourceResult };
  }

  const dataArray = data?.llmCategoryDimensionsRatingSource;
  const sourceDataArray = data?.llmCategoryDimensionsSource;

  if (Array.isArray(dataArray)) {
    dataArray.forEach((entry) => processEntry(entry, ratingSourceResult));
  }

  if (Array.isArray(sourceDataArray)) {
    sourceDataArray.forEach((entry) => processEntry(entry, sourceResult));
  }

  ratingSourceResult = sortDataByMarket(
    ratingSourceResult,
    selectedBrandItems,
    selectedProductItems
  );
  sourceResult = sortDataByMarket(
    sourceResult,
    selectedBrandItems,
    selectedProductItems
  );

  return { ratingSourceResult, sourceResult };
}

function filterBaseResponse(rawData, realPastDate, selectedSubFrequencyItems) {
  return splitByDayAndMonth(
    realPastDate?.day,
    realPastDate?.month,
    realPastDate?.year,
    Array.isArray(rawData) ? rawData : [],
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  )?.filteredData ?? [];
}

export const getCompetitorMetricData = (
  result,
  selectedOptionShow,
  selectedBrandItems,
  selectedProductItems,
  brandName,
  productName,
  selectedSubFrequencyItems,
  brands,
  brandProducts
) => {
  let cumulativeCompData =
    selectedOptionShow === "Product"
      ? result?.coreAttributescumulativeData?.compProducts
      : result?.coreAttributescumulativeData?.compBrands;
  let cumulativebrandOrProductData =
    selectedOptionShow === "Product"
      ? result?.coreAttributescumulativeData?.product
      : result?.coreAttributescumulativeData?.brand;
  cumulativeCompData = splitByDayAndMonth(
    result?.realPastDate?.day,
    result?.realPastDate?.month,
    result?.realPastDate?.year,
    cumulativeCompData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  cumulativebrandOrProductData = splitByDayAndMonth(
    result?.realPastDate?.day,
    result?.realPastDate?.month,
    result?.realPastDate?.year,
    cumulativebrandOrProductData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  const data = transformDataForCoreAttributes(
    cumulativeCompData?.filteredData,
    cumulativebrandOrProductData?.filteredData,
    brandName,
    productName,
    selectedBrandItems,
    selectedProductItems,
    selectedOptionShow
  );

  const remainingData = transformDataForCoreAttributes(
    cumulativeCompData?.remainingData,
    cumulativebrandOrProductData?.remainingData,
    brandName,
    productName,
    selectedBrandItems,
    selectedProductItems,
    selectedOptionShow
  );

  let cumulativeCompCategoryData =
    selectedOptionShow === "Product"
      ? result?.categoryDimCumulativeData?.compProducts
      : result?.categoryDimCumulativeData?.compBrands;
  let cumulativebrandOrProductCategoryData =
    selectedOptionShow === "Product"
      ? result?.categoryDimCumulativeData?.product
      : result?.categoryDimCumulativeData?.brand;
  cumulativeCompCategoryData = splitByDayAndMonth(
    result?.realPastDate?.day,
    result?.realPastDate?.month,
    result?.realPastDate?.year,
    cumulativeCompCategoryData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  cumulativebrandOrProductCategoryData = splitByDayAndMonth(
    result?.realPastDate?.day,
    result?.realPastDate?.month,
    result?.realPastDate?.year,
    cumulativebrandOrProductCategoryData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  const categoryDimdata = transformDataForCategoryDim(
    cumulativeCompCategoryData?.filteredData,
    cumulativebrandOrProductCategoryData?.filteredData,
    brandName,
    productName,
    selectedOptionShow,
    selectedBrandItems,
    selectedProductItems
  );

  const pastCategoryDimData = transformDataForCategoryDim(
    cumulativeCompCategoryData?.remainingData,
    cumulativebrandOrProductCategoryData?.remainingData,
    brandName,
    productName,
    selectedOptionShow,
    selectedBrandItems,
    selectedProductItems
  );

  const cumulativeCompAttributesData =
    selectedOptionShow === "Product"
      ? result?.attributescumulativeData?.compProducts
      : result?.attributescumulativeData?.compBrands;
  const cumulativebrandOrProductAttributesData =
    selectedOptionShow === "Product"
      ? result?.attributescumulativeData?.product
      : result?.attributescumulativeData?.brand;

  const attributesData = transformDataForCompAttributes(
    cumulativeCompAttributesData,
    cumulativebrandOrProductAttributesData,
    selectedOptionShow,
    selectedBrandItems,
    selectedProductItems
  );
const coreAttributeBaseResponse = filterBaseResponse(
  result?.coreAttributescumulativeData?.coreAttributeBaseResponse,
  result?.realPastDate,
  selectedSubFrequencyItems
);

const categoryDimensionBaseResponse = filterBaseResponse(
  result?.categoryDimCumulativeData?.categoryDimensionBaseResponse,
  result?.realPastDate,
  selectedSubFrequencyItems
);

const attributeBaseResponse = filterBaseResponse(
  result?.attributescumulativeData?.attributeBaseResponse,
  result?.realPastDate,
  selectedSubFrequencyItems
);


  const selectedBrandCategory = brands?.data?.data?.filter(
    (data) => data?.brand?.name === selectedBrandItems[0] || brandName
  )[0]?.category?.name;

  const selectedBrandProductCategory = brandProducts?.data?.data?.filter(
    (data) => data?.product?.name === selectedProductItems[0] || productName
  )[0]?.customer_brand_product_categories[0]?.category?.name;

  return {
    data,
    attributesData,
    pastCategoryDimData,
    categoryDimdata,
    remainingData,
    selectedBrandCategory,
    selectedBrandProductCategory,
    coreAttributeBaseResponse,
    categoryDimensionBaseResponse,
    attributeBaseResponse
  };
};

export const getBrandProductOverviewData = (
  result,
  selectedOptionShow,
  value,
  selectedSubFrequencyItems,
  selectedProductItems
) => {
  let cumulativebrandOrProductData =
    selectedOptionShow === "Product"
      ? result?.coreAttributescumulativeData?.product
      : result?.coreAttributescumulativeData?.brand;
  cumulativebrandOrProductData = splitByDayAndMonth(
    result?.realPastDate?.day,
    result?.realPastDate?.month,
    result?.realPastDate?.year,
    cumulativebrandOrProductData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );
  const data = brandCoreAttDataTransform(
    cumulativebrandOrProductData?.filteredData,
    selectedOptionShow,
    value,
    selectedProductItems
  );

  const remainingData = brandCoreAttDataTransform(
    cumulativebrandOrProductData?.remainingData,
    selectedOptionShow,
    value,
    selectedProductItems
  );

  let cumulativeCategoryDimData =
    selectedOptionShow === "Product"
      ? result?.categoryDimCumulativeData?.product
      : result?.categoryDimCumulativeData?.brand;
  cumulativeCategoryDimData = splitByDayAndMonth(
    result?.realPastDate?.day,
    result?.realPastDate?.month,
    result?.realPastDate?.year,
    cumulativeCategoryDimData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );
  const categoryDimData = brandCategoryDimDataTransform(
    cumulativeCategoryDimData?.filteredData,
    selectedOptionShow,
    value,
    selectedProductItems
  );

  const pastCategoryDimData = brandCategoryDimDataTransform(
    cumulativeCategoryDimData?.remainingData,
    selectedOptionShow,
    value,
    selectedProductItems
  );

  let cumulativebrandOrProductAttributesData =
    selectedOptionShow === "Product"
      ? result?.attributescumulativeData?.product
      : result?.attributescumulativeData?.brand;

  cumulativebrandOrProductAttributesData = splitByDayAndMonth(
    result?.realPastDate?.day,
    result?.realPastDate?.month,
    result?.realPastDate?.year,
    cumulativebrandOrProductAttributesData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  const attDataForGraph = transformedGraphData(
    cumulativebrandOrProductAttributesData?.filteredData
  );

  const pastAttDataForGraph = transformedGraphData(
    cumulativebrandOrProductAttributesData?.remainingData
  );

  return {
    data,
    remainingData,
    categoryDimData,
    pastCategoryDimData,
    attDataForGraph,
    pastAttDataForGraph,
  };
};

export const getComparisonDashboardData = (
  result,
  result2,
  selectedBrandItems,
  selectedProductItems,
  value,
  selectedSubFrequencyItems,
  selectedOptionShow,
  brands,
  brandProducts
) => {

  const currentAttData = splitByDayAndMonth(
    result2?.realPastDate?.day,
    result2?.realPastDate?.month,
    result2?.realPastDate?.year,
    result?.cumulativeData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );
  const data = transformDataForAttributes(
    currentAttData?.filteredData,
    value,
    selectedBrandItems,
    selectedProductItems
  );

  const rawIndexScoreData = splitDataObjByDayAndMonth(
    result2?.realPastDate?.day,
    result2?.realPastDate?.month,
    result2?.realPastDate?.year,
    result2?.brandIndexcumulativeData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  let currentBrandIndexScore = getComparisonBrandIndexScore(
    rawIndexScoreData?.filteredData,
    selectedOptionShow,
    value,
    selectedProductItems,
    selectedBrandItems
  );

  let pastBrandIndexScore = getComparisonBrandIndexScore(
    rawIndexScoreData?.remainingData,
    selectedOptionShow,
    value,
    selectedProductItems,
    selectedBrandItems
  );

  let cumulativebrandOrProductCoreAttData =
    selectedOptionShow === "Product"
      ? result2?.coreAttributescumulativeData?.product
      : result2?.coreAttributescumulativeData?.brand;

  cumulativebrandOrProductCoreAttData = splitByDayAndMonth(
    result2?.realPastDate?.day,
    result2?.realPastDate?.month,
    result2?.realPastDate?.year,
    cumulativebrandOrProductCoreAttData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );
  const coreAttdata = brandCoreAttDataTransform(
    cumulativebrandOrProductCoreAttData?.filteredData,
    selectedOptionShow,
    value,
    selectedProductItems
  );
  const pastCoreAttdata = brandCoreAttDataTransform(
    cumulativebrandOrProductCoreAttData?.remainingData,
    selectedOptionShow,
    value,
    selectedProductItems
  );

  let cumulativebrandOrProductCategoryDimData =
    selectedOptionShow === "Product"
      ? result2?.categoryDimCumulativeData?.product
      : result2?.categoryDimCumulativeData?.brand;

  cumulativebrandOrProductCategoryDimData = splitByDayAndMonth(
    result2?.realPastDate?.day,
    result2?.realPastDate?.month,
    result2?.realPastDate?.year,
    cumulativebrandOrProductCategoryDimData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  const categoryDimdata = brandCategoryDimDataTransform(
    cumulativebrandOrProductCategoryDimData?.filteredData,
    selectedOptionShow,
    value,
    selectedProductItems
  );
  const pastCategoryDimdata = brandCategoryDimDataTransform(
    cumulativebrandOrProductCategoryDimData?.remainingData,
    selectedOptionShow,
    value,
    selectedProductItems
  );

  const brandIndexFromFavAndRach = combineData(
    calculateAverageData(currentBrandIndexScore?.brandFavData)?.["avg"],
    calculateAverageData(currentBrandIndexScore?.brandReachData, true)?.["avg"]
  );

  const pastBrandIndexFromFavAndRach = combineData(
    calculateAverageData(pastBrandIndexScore?.brandFavData)?.["avg"],
    calculateAverageData(pastBrandIndexScore?.brandReachData, true)?.["avg"]
  );

  const selectedBrandCategory = brands?.data?.data?.filter(
    (data) => data?.brand?.name === selectedBrandItems[0]
  )[0]?.category?.name;

  const selectedBrandProductCategory = brandProducts?.data?.data?.filter(
    (data) => data?.product?.name === selectedProductItems[0]
  )[0]?.customer_brand_product_categories[0]?.category?.name;

  return {
    data,
    coreAttdata,
    pastCoreAttdata,
    categoryDimdata,
    pastCategoryDimdata,
    brandIndexFromFavAndRach,
    pastBrandIndexFromFavAndRach,
    selectedBrandCategory,
    selectedBrandProductCategory,
    currentBrandIndexScore,
    pastBrandIndexScore,
  };
};

export const getSecondaryCategoryIndexScoreData = (
  result2,
  selectedBrandItems,
  selectedProductItems,
  value,
  selectedSubFrequencyItems,
  selectedOptionShow
) => {
  const rawIndexScoreData = splitDataObjByDayAndMonth(
    result2?.realPastDate?.day,
    result2?.realPastDate?.month,
    result2?.realPastDate?.year,
    result2?.secBrandIndexcumulativeData,
    selectedSubFrequencyItems === "Current",
    selectedSubFrequencyItems === "Custom"
  );

  let currentBrandIndexScore = getSecCategoryComparisonBrandIndexScore(
    rawIndexScoreData?.filteredData,
    selectedOptionShow,
    value,
    selectedProductItems,
    selectedBrandItems
  );

  let pastBrandIndexScore = getSecCategoryComparisonBrandIndexScore(
    rawIndexScoreData?.remainingData,
    selectedOptionShow,
    value,
    selectedProductItems,
    selectedBrandItems
  );

  const brandIndexFromFavAndRach = {};
  const pastBrandIndexFromFavAndRach = {};

  Object.keys(currentBrandIndexScore || {}).forEach((categoryId) => {
    brandIndexFromFavAndRach[categoryId] = combineData(
      calculateAverageData(
        currentBrandIndexScore?.[categoryId]?.brandFavData
      )?.["avg"],
      calculateAverageData(
        currentBrandIndexScore?.[categoryId]?.brandReachData,
        true
      )?.["avg"]
    );
  });

  Object.keys(pastBrandIndexScore || {}).forEach((categoryId) => {
    pastBrandIndexFromFavAndRach[categoryId] = combineData(
      calculateAverageData(pastBrandIndexScore?.[categoryId]?.brandFavData)?.[
      "avg"
      ],
      calculateAverageData(
        pastBrandIndexScore?.[categoryId]?.brandReachData,
        true
      )?.["avg"]
    );
  });

  return {
    brandIndexFromFavAndRach,
    pastBrandIndexFromFavAndRach,
    currentBrandIndexScore,
    pastBrandIndexScore,
  };
};

export const getSecCategoryComparisonBrandIndexScore = (
  data,
  selectedOptionShow,
  value,
  selectedProductItems,
  selectedBrandItems
) => {
  if (!data) return {};

  // Group the data by category_id
  const groupedData = {};

  const cumulativeCompData =
    selectedOptionShow === "Product" ? data?.compProducts : data?.compBrands;
  const cumulativeBrandOrProductData =
    selectedOptionShow === "Product" ? data?.product : data?.brand;

  // Combine compData and brandData into one array for grouping
  const combinedData = [
    ...(cumulativeCompData || []),
    ...(cumulativeBrandOrProductData || []),
  ];

  combinedData.forEach((item) => {
    const categoryId = item.category?.name;
    if (!groupedData[categoryId]) {
      groupedData[categoryId] = {
        compData: [],
        brandData: [],
      };
    }

    if (cumulativeCompData?.includes(item)) {
      groupedData[categoryId].compData.push(item);
    } else {
      groupedData[categoryId].brandData.push(item);
    }
  });

  // Now, for each category_id, call the existing transform logic
  const result = {};

  Object.keys(groupedData).forEach((categoryId) => {
    const { compData, brandData } = groupedData[categoryId];

    const brandIndexData = transformBrandIndexMultiLlmData(
      compData,
      brandData,
      "avg_brand_index_score",
      selectedOptionShow,
      value,
      selectedProductItems,
      selectedBrandItems
    );

    const brandFavData = transformBrandIndexMultiLlmData(
      compData,
      brandData,
      "avg_brand_favorability_score",
      selectedOptionShow,
      value,
      selectedProductItems,
      selectedBrandItems
    );

    const brandReachData = transformBrandIndexMultiLlmData(
      compData,
      brandData,
      "avg_brand_reach_score",
      selectedOptionShow,
      value,
      selectedProductItems,
      selectedBrandItems
    );

    result[categoryId] = {
      brandIndexData,
      brandFavData,
      brandReachData,
    };
  });

  return result;
};

export function transformProductDimensions(data, targetProductName) {
  if (!data || data.length === 0) return;
  return data?.map((pillar) => {
    const product = pillar?.products?.find((p) => p.name === targetProductName);
    return {
      name: pillar?.name,
      score: product ? Number(product?.score).toFixed(0) : null,
    };
  });
}

export const toDate = (str) => {
  const [mm, dd, yyyy] = str.split("-");
  return new Date(`${yyyy}-${mm}-${dd}`);
};

export function filterRecentByBrandId(data) {
  if (!data || data.length === 0) return []
  const brandIdKey = data?.find(item => item.comp_brand_id || item.comp_brand_product_id)
    ? (item => item.comp_brand_id || item.comp_brand_product_id)
    : null;

  if (brandIdKey) {
    const map = new Map();
    for (const item of data) {
      const id = brandIdKey(item);
      if (!id) continue;

      const existing = map.get(id);
      const currentDate = new Date(item.main_date_added);
      const existingDate = existing ? new Date(existing.main_date_added) : null;

      if (!existing || currentDate > existingDate) {
        map.set(id, item);
      }
    }
    return Array.from(map.values());
  } else {
    // No brand IDs present — return only the single object with the most recent date_added
    return data?.reduce((latest, item) => {
      return !latest || new Date(item.date_added) > new Date(latest.date_added)
        ? item
        : latest;
    }, null) ? [data.reduce((latest, item) => {
      return !latest || new Date(item.date_added) > new Date(latest.date_added)
        ? item
        : latest;
    }, null)] : [];
  }
}

export const prepareSourceDataForExcel = (input, selectedInput, labelMapping, sourceFilter) => {
  const result = {};

  input?.forEach(obj => {
    const allUrls = [];

    // Collect all urls with http_status, alias_absolute_count, and targetParameter
    Object.keys(obj).forEach(key => {
      if (key !== "name" && obj[key]?.aliases) {
        obj[key].aliases.forEach(alias => {
          if (alias.source_alias_url) {
            allUrls.push({
              url: alias.source_alias_url,
              http_status: alias.http_status,
              alias_absolute_count: parseFloat(alias.alias_absolute_count || 0) || 0,
              ...selectedInput, [labelMapping[sourceFilter?.value]]: key
            });
          }
        });
      }
    });

    // Initialize array if name not yet present
    if (!result[obj.name]) {
      result[obj.name] = [];
    }

    // Merge collected URLs with existing ones for the same name
    result[obj.name] = result[obj.name].concat(allUrls);
  });

  // Deduplicate each name's URLs based on 'url'
  Object.keys(result).forEach(name => {
    const aggregatedMap = {};

    result[name].forEach(item => {
      const uniqueKey = `${item.url}-${item.llm}-${item.category}-${item.persona}`
      const existing = aggregatedMap[uniqueKey];
      if (existing) {
        // Aggregate alias_absolute_count if duplicate URL found
        existing.alias_absolute_count += parseFloat(item.alias_absolute_count || '0') || 0;
      } else {
        aggregatedMap[uniqueKey] = { ...item };
      }
    });

    // Convert back to array
    result[name] = Object.values(aggregatedMap);
  });

  return result;
};

export const downloadExcel = (
  finalsources,
  label,
  selectedInput,
  sentimentQuestion = "",
  isShowValidationStatus = true,
  headerBg = "FF4F81BD",
  urlColWidth = 100,
) => {
  let data = [];
  let headers = [];

  // Build common Configuration text (same for all rows)
  const commonConfiguration = [];

  const brand = selectedInput?.brand || selectedInput?.product || "";
  if (brand) commonConfiguration.push(`Brand/Product: ${brand}`);

  const category = selectedInput?.category || "";
  if (category) commonConfiguration.push(`Category: ${category}`);

  const persona = selectedInput?.persona || "";
  if (persona) commonConfiguration.push(`Persona: ${persona}`);

  const llm = selectedInput?.llm || "";
  if (llm) commonConfiguration.push(`LLM: ${llm}`);

  const geography = selectedInput?.geography || "";
  if (geography) commonConfiguration.push(`Geography: ${geography}`);

  const market = selectedInput?.market || "";
  if (market) commonConfiguration.push(`Market: ${market}`);

  const ConfigurationText = commonConfiguration.join("\n");

  const isArrayOfStrings =
    Array.isArray(finalsources) && finalsources.every((item) => typeof item === "string");

  if (isArrayOfStrings) {
    // ✅ Case 1: finalsources is an array of strings (just URLs)
    finalsources = finalsources.filter((key) => !key.toLowerCase().includes("vertexaisearch"))
    data = finalsources.map((url) => ({
      "Full URL(s)": url,
      ...(sentimentQuestion ? { "Sentiment Question": sentimentQuestion } : {}),
      Configuration: ConfigurationText,
    }));

    headers = [
      "Full URL(s)",
      ...(sentimentQuestion ? ["Sentiment Question"] : []),
      "Configuration",
    ];
  } else {
    // ✅ Case 2: finalsources is object keyed by domain
    finalsources = Object.fromEntries(
      Object.entries(finalsources).filter(([key]) => !key.toLowerCase().includes("vertexaisearch"))
    );
    Object.keys(finalsources || {}).forEach((domain) => {
      finalsources[domain].forEach((item) => {
        const row = {
          "Domain URL": domain,
          "Full URL(s)": item.url,
          Configuration: ConfigurationText,
        };

        if (isShowValidationStatus) {
          row["Validation Status"] =
            item?.http_status === "200" || selectedInput?.llm === "gpt-5-search-enabled"
              ? "Validated"
              : "Unvalidated";
        }

        data.push(row);
      });
    });


    data.sort((a, b) => {
      const countA = Number(a["Citation/Identification Count"]) || 0;
      const countB = Number(b["Citation/Identification Count"]) || 0;
      return countB - countA;
    });

    headers = [
      "Domain URL",
      "Full URL(s)",
      ...(isShowValidationStatus ? ["Validation Status"] : []),
      "Configuration",
    ];
  }

  // After sorting/building, keep Configuration only in first row
  data.forEach((row, idx) => {
    if (idx > 0) {
      row["Configuration"] = "";
    }
  });

  // ✅ create sheet
  const ws = XLSX.utils.json_to_sheet(data, { header: headers });

  // ✅ column widths
  ws["!cols"] = headers.map((header) => {
    if (header === "Full URL(s)") return { wch: urlColWidth };
    if (header === "Domain URL") return { wch: 30 };
    if (header === "Validation Status") return { wch: 20 };
    if (header === "Sentiment Question") return { wch: 40 };
    if (header === "Configuration") return { wch: 40 };
    return { wch: 20 };
  });

  // ✅ Merge Configuration column for ALL rows
  const range = XLSX.utils.decode_range(ws["!ref"]);
  const ConfigurationColIndex = headers.indexOf("Configuration");

  if (ConfigurationColIndex !== -1 && data.length > 0) {
    ws["!merges"] = [{
      s: { r: 1, c: ConfigurationColIndex }, // Start from row 1 (after header)
      e: { r: range.e.r, c: ConfigurationColIndex } // End at last row
    }];
  }

  // ✅ wrap text for full URLs
  const fullUrlIndex = headers.indexOf("Full URL(s)");
  for (let R = range.s.r + 1; R <= range.e.r; ++R) {
    const cellRef = XLSX.utils.encode_cell({ r: R, c: fullUrlIndex });
    if (ws[cellRef]) {
      ws[cellRef].s = ws[cellRef].s || {};
      ws[cellRef].s.alignment = { wrapText: true, vertical: "top" };
    }
  }

  // ✅ Configuration column styling (only first cell since it's merged)
  if (ConfigurationColIndex !== -1) {
    const ConfigurationCell = XLSX.utils.encode_cell({ r: 1, c: ConfigurationColIndex });
    if (ws[ConfigurationCell]) {
      ws[ConfigurationCell].s = {
        alignment: { wrapText: true, vertical: "top", horizontal: "left" }
      };
    }
  }

  // ✅ style headers
  const headerStyle = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    alignment: { horizontal: "center", vertical: "center" },
    fill: {
      patternType: "solid",
      fgColor: { rgb: headerBg },
      bgColor: { rgb: headerBg },
    },
  };

  headers.forEach((_, index) => {
    const colLetter = XLSX.utils.encode_col(index);
    const addr = `${colLetter}1`;
    if (ws[addr]) ws[addr].s = headerStyle;
  });

  // ✅ finalize workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Report");

  const fileName = label ? `${label}_sources_report.xlsx` : "sources_report.xlsx";
  XLSX.writeFile(wb, fileName);
};

export const downloadExcelV2 = (
  finalsources,
  multiValueField = null, // "persona" | "llm" | "category" | null
  isShowValidationStatus = true,
  label,
  selectedInput,
  headerBg = "FF4F81BD",
  urlColWidth = 100,

) => {
  finalsources = Object.fromEntries(
    Object.entries(finalsources).filter(([key]) => !key.toLowerCase().includes("vertexaisearch"))
  );
  let data = [];

  // Get common Configuration values (same for ALL rows)
  const firstDomain = Object.keys(finalsources)[0];
  const firstItem = finalsources[firstDomain][0];
  const commonConfiguration = [];

  console.log('firtsitem==>', firstItem)

  const brand = firstItem?.brand || firstItem?.product || "";
  if (brand) commonConfiguration.push(`Brand/Product: ${brand}`);

  if (multiValueField !== "category") {
    const category = firstItem?.category || "";
    if (category) commonConfiguration.push(`Category: ${category}`);
  }

  if (multiValueField !== "persona") {
    const persona = firstItem?.persona || "";
    if (persona) commonConfiguration.push(`Persona: ${persona}`);
  }

  if (multiValueField !== "llm") {
    const llm = firstItem?.llm || "";
    if (llm) commonConfiguration.push(`LLM: ${llm}`);
  }

  const geography = firstItem?.geography || "";
  if (geography) commonConfiguration.push(`Geography: ${geography}`);

  const market = firstItem?.market || "";
  if (market) commonConfiguration.push(`Market: ${market}`);

  const ConfigurationText = commonConfiguration.join("\n");

  // Build array
  Object.keys(finalsources).forEach((domain, mainIndex) => {
    finalsources[domain].forEach((item, index) => {
      const row = {
        "Domain URL": domain,
        "Full URL(s)": item.url,
        "Citation/Identification Count": item?.alias_absolute_count || ""
      };

      // only include Validation Status if requested
      if (isShowValidationStatus) {
        row["Validation Status"] = (item?.http_status === "200" || item?.llm === 'gpt-5-search-enabled') ? " Validated" : "Unvalidated";
      }

      // Add multi-value field if specified
      if (multiValueField === "persona") {
        row["Persona"] = item?.persona || "";
      } else if (multiValueField === "llm") {
        row["LLM"] = item?.llm || "";
      } else if (multiValueField === "category") {
        row["Category"] = item?.category || "";
      }


      row["Configuration"] = ConfigurationText;

      data.push(row);
    });
  });

  // Sort by status: Valid first, then Invalid
  if (isShowValidationStatus) {

    data.sort((a, b) => {
      const countA = Number(a["Citation/Identification Count"]) || 0;
      const countB = Number(b["Citation/Identification Count"]) || 0;
      return countB - countA;
    });
  } else {
    data.sort((a, b) => a["Domain URL"].localeCompare(b["Domain URL"]));
  }

  // After sorting, keep Configuration only in first row
  data.forEach((row, idx) => {
    if (idx > 0) {
      row["Configuration"] = "";
    }
  });

  // Define column order based on multiValueField
  const headers = [
    "Domain URL",
    "Full URL(s)",
    "Citation/Identification Count",
    ...(isShowValidationStatus ? ["Validation Status"] : []),
  ];

  if (multiValueField === "persona") headers.push("Persona");
  else if (multiValueField === "llm") headers.push("LLM");
  else if (multiValueField === "category") headers.push("Category");

  headers.push("Configuration");

  // Create sheet
  const ws = XLSX.utils.json_to_sheet(data, { header: headers });

  // Column widths
  const colWidths = [
    { wch: 30 },  // Domain URL
    { wch: urlColWidth },  // Full URL(s)
    { wch: 30 },  // Citation Count
    ...(isShowValidationStatus ? [{ wch: 20 }] : []),// Validation Status
  ];

  if (multiValueField) {
    colWidths.push({ wch: 20 }); // Multi-value field
  }

  colWidths.push({ wch: 40 }); // Configuration

  ws["!cols"] = colWidths;

  // Merge Configuration column for ALL rows
  const range = XLSX.utils.decode_range(ws["!ref"]);
  const ConfigurationColIndex = headers.length - 1;

  ws["!merges"] = [{
    s: { r: 1, c: ConfigurationColIndex }, // Start from row 1 (after header)
    e: { r: range.e.r, c: ConfigurationColIndex } // End at last row
  }];

  // Apply styling
  for (let R = range.s.r + 1; R <= range.e.r; ++R) {
    // Full URLs column wrap
    const urlCell = XLSX.utils.encode_cell({ r: R, c: 1 });
    if (ws[urlCell]) {
      ws[urlCell].s = {
        alignment: { wrapText: true, vertical: "top" }
      };
    }
  }

  // Configuration column styling (only first cell since it's merged)
  const ConfigurationCell = XLSX.utils.encode_cell({ r: 1, c: ConfigurationColIndex });
  if (ws[ConfigurationCell]) {
    ws[ConfigurationCell].s = {
      alignment: { wrapText: true, vertical: "top", horizontal: "left" }
    };
  }

  // Style headers
  const headerStyle = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    alignment: { horizontal: "center", vertical: "center" },
    fill: {
      patternType: "solid",
      fgColor: { rgb: headerBg },
      bgColor: { rgb: headerBg },
    },
  };

  headers.forEach((_, index) => {
    const colLetter = XLSX.utils.encode_col(index);
    const addr = `${colLetter}1`;
    if (ws[addr]) ws[addr].s = headerStyle;
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Report");

  const fileName = label ? `${label}_sources_report.xlsx` : "sources_report.xlsx";
  XLSX.writeFile(wb, fileName);
};

export const downloadExcelV3 = (
  finalsources,
  multiValueField = null, // "persona" | "llm" | "category" | null
  isShowValidationStatus = true,
  label,
  selectedInput,
  headerBg = "FF4F81BD"
) => {
  finalsources = Object.fromEntries(
    Object.entries(finalsources).filter(([key]) => !key.toLowerCase().includes("vertexaisearch"))
  );

  let data = [];

  // === Common configuration (same for all rows) ===
  const firstDomain = Object.keys(finalsources)[0];
  const firstItem = finalsources[firstDomain]?.[0];
  const commonConfiguration = [];

  const brand = firstItem?.brand || firstItem?.product || "";
  if (brand) commonConfiguration.push(`Brand/Product: ${brand}`);

  if (multiValueField !== "category") {
    const category = firstItem?.category || "";
    if (category) commonConfiguration.push(`Category: ${category}`);
  }

  if (multiValueField !== "persona") {
    const persona = firstItem?.persona || "";
    if (persona) commonConfiguration.push(`Persona: ${persona}`);
  }

  if (multiValueField !== "llm") {
    const llm = firstItem?.llm || "";
    if (llm) commonConfiguration.push(`LLM: ${llm}`);
  }

  const geography = firstItem?.geography || "";
  if (geography) commonConfiguration.push(`Geography: ${geography}`);

  const market = firstItem?.market || "";
  if (market) commonConfiguration.push(`Market: ${market}`);

  const ConfigurationText = commonConfiguration.join("\n");

  // === Dynamic grouping based on multiValueField ===
  Object.keys(finalsources).forEach((domain) => {
    const items = finalsources[domain];

    // Build a Map for dynamic grouping
    const groupMap = new Map();

    items.forEach((item) => {
      let groupKey = domain; // default group key

      if (multiValueField === "llm") groupKey += `|${item.llm || "Unknown"}`;
      else if (multiValueField === "persona") groupKey += `|${item.persona || "Unknown"}`;
      else if (multiValueField === "category") groupKey += `|${item.category || "Unknown"}`;

      if (!groupMap.has(groupKey)) groupMap.set(groupKey, []);
      groupMap.get(groupKey).push(item);
    });

    // Convert each group into one Excel row
    groupMap.forEach((groupItems, key) => {
      const totalCount = groupItems.reduce(
        (sum, i) => sum + (Number(i.alias_absolute_count) || 0),
        0
      );

      const isValid = groupItems.some(
        (i) => i?.http_status === "200" || i?.llm === "gpt-5-search-enabled"
      );

      const sampleItem = groupItems[0];
      const row = {
        "Domain URL": domain,
        "Citation/Identification Count": totalCount,
      };

      if (isShowValidationStatus) {
        row["Validation Status"] = isValid ? "Validated" : "Unvalidated";
      }

      if (multiValueField === "llm") row["LLM"] = sampleItem?.llm || "Unknown";
      else if (multiValueField === "persona") row["Persona"] = sampleItem?.persona || "Unknown";
      else if (multiValueField === "category") row["Category"] = sampleItem?.category || "Unknown";

      row["Configuration"] = ConfigurationText;

      data.push(row);
    });
  });

  // === Sort by count descending ===
  data.sort((a, b) => (b["Citation/Identification Count"] || 0) - (a["Citation/Identification Count"] || 0));

  // === Only first row keeps configuration ===
  data.forEach((row, idx) => {
    if (idx > 0) row["Configuration"] = "";
  });

  // === Build headers dynamically ===
  const headers = ["Domain URL"];

  if (multiValueField === "llm") headers.push("LLM");
  else if (multiValueField === "persona") headers.push("Persona");
  else if (multiValueField === "category") headers.push("Category");

  headers.push("Citation/Identification Count");
  if (isShowValidationStatus) headers.push("Validation Status");
  headers.push("Configuration");

  // === Generate Excel sheet ===
  const ws = XLSX.utils.json_to_sheet(data, { header: headers });

  // === Column widths ===
  const colWidths = [{ wch: 30 }]; // Domain
  if (multiValueField) colWidths.push({ wch: 20 }); // multi field
  colWidths.push({ wch: 25 }); // Count
  if (isShowValidationStatus) colWidths.push({ wch: 20 }); // Status
  colWidths.push({ wch: 40 }); // Config
  ws["!cols"] = colWidths;

  // === Merge config cells ===
  const range = XLSX.utils.decode_range(ws["!ref"]);
  const configColIndex = headers.length - 1;
  ws["!merges"] = [
    {
      s: { r: 1, c: configColIndex },
      e: { r: range.e.r, c: configColIndex },
    },
  ];

  // === Header styling ===
  const headerStyle = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    alignment: { horizontal: "center", vertical: "center" },
    fill: {
      patternType: "solid",
      fgColor: { rgb: headerBg },
      bgColor: { rgb: headerBg },
    },
  };

  headers.forEach((_, idx) => {
    const addr = `${XLSX.utils.encode_col(idx)}1`;
    if (ws[addr]) ws[addr].s = headerStyle;
  });

  // === Config cell styling ===
  const configCell = XLSX.utils.encode_cell({ r: 1, c: configColIndex });
  if (ws[configCell]) {
    ws[configCell].s = {
      alignment: { wrapText: true, vertical: "top", horizontal: "left" },
    };
  }

  // === Save Excel file ===
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Report");

  const fileName = label ? `${label}_sources_report.xlsx` : "sources_report.xlsx";
  XLSX.writeFile(wb, fileName);
};

export function getColorCode(value, maxValue, metricType) {
  let color;

  if (metricType === 'RBI') {
    const score = Number(value).toFixed(0);

    if (score >= 0 && score <= 30) {
      color = "#dc3545"
    } else if (score >= 31 && score <= 50) {
      color = "#f9cf4a";
    } else if (score >= 51 && score <= 70) {
      color = "#f77103";
    } else if (score >= 71) {
      color = "#198754"; // green
    }

    return color
  }

  if (metricType === 'visibility' || metricType === 'propensity-visibility') {
    const score = Number(value).toFixed(0);
    color = "#dc3545"; // default red
    if (score > 0 && score <= 39) {
      color = "#f77103"; // yellow
    } else if (score >= 40) {
      color = "#198754"; // green
    }
    return color
  }

  if (value >= maxValue - 1) color = "#198754"; // Green
  else if (value >= maxValue - 5 && value <= maxValue - 2) color = "#f77103"; // Yellow
  else if (value <= maxValue - 6) color = "#dc3545"; // Red
  else color = "#6c757d"; // Grey (fallback)
  return color;
}
